import { Add } from "@carbon/icons-react";
import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import UIkit from "uikit";
import Constants from "../../../../utils/Constants";
import swal from 'sweetalert';
import { DecryptData } from "../../../../utils/Cipher";
import { usePermissions } from "../../../../context/PermissionsContext";


const Comments = ({ data, id ,status , refetch }) => {
  const [loader, setLoader] = useState(false);

  // const [data, setcmntdata] = useState(data);


  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const openModal = () => {
    UIkit.modal("#comment").show();
  };

  const {Permissions} = usePermissions();
  const user = DecryptData();


  const Submit = (data) => {

    setLoader(true);


    axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: { comment : data.comment , orderId: id },
      url: Constants.url + `comments/add`,
    })
      .then((res) => {
        setLoader(false);
        
        if(res.data.status === 'success' ){
          // var newdata = res.data.data.comment
          // setcmntdata([...data, newdata])
          
          window.swal({
            icon:'success',
            title:'success' 
          }).then(() => UIkit.modal("#comment").hide() )
          refetch();

        }
      })
      .catch((err) => {
      });
  };

  return (
    <>
      {/* Modal */}

      <div
        id="comment"
        container="#pageId"
        uk-modal=""
        style={{ paddingTop: "180px" }}
      >
        <div className="uk-modal-dialog uk-modal-body uk-card uk-card-default uk-card-hover uk-width-large ">
          <button className="uk-modal-close-default" type="button" uk-close>
            X
          </button>

          <h3 className="uk-text-bold uk-text-light">Add Comment</h3>

          <form
            className="uk-form-stacked uk-padding"
            onSubmit={handleSubmit(Submit)}
          >
            <div>
              <label className="uk-form-label-large" htmlFor="form-name">
                Comment
              </label>
              <div className="uk-form-controls">
                <input
                  className="uk-input uk-form-medium"
                  id="form-name"
                  type="text"
                  placeholder=""
                  {...register("comment", { required: "Field is required" })}
                />
              </div>
            </div>

            <div className="uk-margin uk-flex uk-flex-center">
              <button
                className="uk-button uk-button-secondary uk-button-medium uk-width-1-1"
                type="submit"
              >
                {loader ? <div uk-spinner="" className="loader"></div> : "Add"}
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* -------------- */}

      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-1">
          <div className="analyticsTableWrp ">
          {Permissions?.includes("oms-coment") && (
          status === 'delivered'  || status === 'cancelled' || status === 'incart' ? '': 
            <div className="right">
              <button
                onClick={openModal}
                className="uk-button uk-button-secondary"
              >
                Add <Add size={24} />
              </button>
            </div> 
            )}
            <table className="uk-table  uk-table-hover">
              <thead className="dropdownsum">
                <tr>
                  <th className='uk-table-shrink'>S.No</th>
                  <th>Comment</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{row.comment ? row.comment : '-'}</td>
                      <td>
                        {" "}
                        {row.createdAt
                          ? new Date(row.createdAt).toLocaleString("en-US", {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            // second: "2-digit", // optional, if you need seconds
                            hour12: true,      // for 12-hour format
                            timeZone: "Asia/Karachi",
                          })
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="uk-text-center" colSpan={3}>
                      {" "}
                      Record Not Found{" "}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Comments;
